import { render, staticRenderFns } from "./DetailedCharts.vue?vue&type=template&id=3b23cbb4&scoped=true&"
import script from "./DetailedCharts.vue?vue&type=script&lang=js&"
export * from "./DetailedCharts.vue?vue&type=script&lang=js&"
import style0 from "./DetailedCharts.vue?vue&type=style&index=0&id=3b23cbb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23cbb4",
  null
  
)

export default component.exports